import React from "react";

export interface ConfirmationModalState {
  children?: React.ReactElement;
}

export const initialState: ConfirmationModalState = {
  children: undefined,
};
